import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onClose", "isFullScreen", "showSkeleton", "onCartItemEdit", "emptyCartMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CartModal as SharedCartModal } from '~shared/segments/Cart';
import { CartContent } from './CartContent';
import { CartSubmitButton } from './CartSubmitButton';
import { jsx as _jsx } from "react/jsx-runtime";
var modalBodyPadding = "medium";
var modalBg = "bgColors.primary";
/**
 * Full screen drawer cart OR modal with centered cart,
 * depending on `isFullScreen` prop.
 */

export var CartModal = function CartModal(_ref) {
  var onClose = _ref.onClose,
      isFullScreen = _ref.isFullScreen,
      showSkeleton = _ref.showSkeleton,
      _onCartItemEdit = _ref.onCartItemEdit,
      emptyCartMessage = _ref.emptyCartMessage,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(SharedCartModal, _objectSpread(_objectSpread({
    onClose: onClose,
    isFullScreen: isFullScreen,
    showSkeleton: showSkeleton,
    cartSubmitButton: /*#__PURE__*/_jsx(CartSubmitButton, {
      onBackClick: isFullScreen ? onClose : undefined
    })
  }, props), {}, {
    children: /*#__PURE__*/_jsx(CartContent, {
      isCartEditable: true,
      bgColor: modalBg,
      totalVariant: "none",
      showSkeleton: showSkeleton,
      emptyCartMessage: emptyCartMessage,
      emptyCartContainerProps: {
        margin: {
          top: "none",
          left: "none",
          right: "none",
          bottom: modalBodyPadding
        }
      } // this is a hack to make the cart item scrollable
      // chakra-ui drawers needs to be nested to make the second drawer scrollable
      // this is not possible with the current implementation, co we are closing/re-opening the cart drawer on item edit
      // https://github.com/chakra-ui/chakra-ui/issues/7254
      ,
      onCartItemEdit: function onCartItemEdit(cartItem) {
        _onCartItemEdit === null || _onCartItemEdit === void 0 ? void 0 : _onCartItemEdit(cartItem);
        onClose();
      }
    })
  }));
};